<nav class="bg-gray-800 flex flex-row justify-between items-center">
  <div class="flex flex-row ml-10 mr-4 p-2 items-center">
    <div class="h-10 w-10 rounded-full mr-4 bg-gray-50 bg-opacity-0">
      <img src="assets/images/musix-logo.svg" alt="">
    </div>
    <!-- <img src="assets/images/logo.svg" alt="" width="50" height="50" class="m-2"> -->
    <a class="font-bold text-xl text-gray-50 hover:text-green-200" [routerLink]="['/dashboard']" routerLinkActive="router-link-active" >Spotlight</a>
    <!-- <div class="h-10 w-10 rounded-full mr-4 bg-gray-50"></div> -->
  </div>
  <div class="flex flex-row justify-between items-center">
    <div class="mr-6 ml-4 cursor-pointer">
      <img src="assets/images/search.svg" (click)="clickEvent()" alt="" class="h-6 w-6 bg-contain">
    </div>
    <div class="ml-2 rounded-full mr-10 bg-gray-50 cursor-pointer" (click)="show = !show">
      <img [src]="photo" class="rounded-full h-10 w-10">
    </div>
  </div>
  
  </nav>

  <div *ngIf="show" class="border-gray-400 p-6 m-4 fixed right-0 bg-gray-100 rounded-lg shadow-lg flex flex-col">
    <p class="text-sm font-medium md-1">{{name}}</p>
    <button class="text-sm font-medium mt-1 hover:text-green-200" (click)="auth.logout({ returnTo: 'https://www.google.com' })">Log out</button>
  </div>
